export default {"src":"/_next/static/media/vr.ab4a6c76.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};